var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 256c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 42.1 96 96 0 53-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8 6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96c-53.9 0-96.9-43-96.9-96 0-53.9 43-96 96.9-96h42.1c-21.9-30.5-42.1-66.6-42.1-96 0-53.02 42.1-96 96-96 53 0 96 42.98 96 96 0 64-96 160-96 160h-96zm96-128c17.7 0 32-14.3 32-32 0-17.67-14.3-32-32-32s-32 14.33-32 32c0 17.7 14.3 32 32 32zM118.3 487.8l-.6.6c-4.3 5-8.2 9.3-11.4 12.8-.4.4-.8.8-1.1 1.2-5.7 6.1-9.2 9.6-9.2 9.6S0 416 0 352c0-53.9 42.98-96.9 96-96.9 53 0 96 43 96 96.9 0 29.4-20.2 65.5-42.1 96-11.8 15.2-22.2 28.9-31.6 39.8zM95.1 384c18.6 0 32-14.3 32-32s-13.4-32-32-32c-16.77 0-32 14.3-32 32s15.23 32 32 32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.27bbd85111bba88ef213dd0ec5b97c72.svg";
export { ForwardRef as ReactComponent };